import { render, staticRenderFns } from "./OperatnLuogoNascita.vue?vue&type=template&id=206dfdc6&"
import script from "./OperatnLuogoNascita.vue?vue&type=script&lang=ts&"
export * from "./OperatnLuogoNascita.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports